// extracted by mini-css-extract-plugin
export default {"navLeft":"ContentPage_navLeft__7d4M6"};